import React, { useEffect } from 'react'
import * as THREE from 'three'
import * as CANNON from 'cannon'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'
import "./Pi.css"
import { CubicBezierCurve } from 'three'
function Pi() {
    useEffect(()=>{
     
        const textureLoader = new THREE.TextureLoader()
        const normalTexture= textureLoader.load("./ball_normal.jpg");
        console.log(normalTexture);

// Debug
const gui = new dat.GUI()
// Canvas
const canvas = document.querySelector('canvas.webgl')
gui.closed=true;
// Scene
const scene = new THREE.Scene()

// Objects
const geometry = new THREE.TorusGeometry( .7, .2, 16, 100 );
const material=new THREE.MeshStandardMaterial( { wireframe: false });
material.color.setRGB(0,220,0);
let A=new THREE.Mesh(geometry,material);

A.material.color.setHex(0x00ff00);


let pointLight = new THREE.PointLight(0xffffff, 0.4)
pointLight.position.set(0,10,10);
scene.add(pointLight);

let pointLight2 = new THREE.PointLight(0xffffff, 0.1)
pointLight2.position.set(10,0,0);
scene.add(pointLight2);


const ambientLight=new THREE.AmbientLight(0xffffff,0.6);
scene.add(ambientLight);

const directionalLight= new THREE.DirectionalLight(0xffffff,1.6);
// directionalLight.position.set(100,-300,400);
directionalLight.position.set(1000,1000,1000);
// scene.add(directionalLight);
gui.add(directionalLight.position,"x",-300,1000);
gui.add(directionalLight.position,"y",-300,1000);
gui.add(directionalLight.position,"z",-300,1000);

const axesHelper = new THREE.AxesHelper( 50 );
scene.add( axesHelper );

//CANNON JS
var world = new CANNON.World();
world.gravity.set(0,0,-10);
// Create a sphere

let sphere_posx=2;
let sphere_posy=0;
let sphere_posz=3;

var radius = 0.1; // m
var sphereBody = new CANNON.Body({
   mass: 50, // kg
   position: new CANNON.Vec3(sphere_posx, sphere_posy, sphere_posz), // m
   shape: new CANNON.Sphere(radius),
   

});
world.addBody(sphereBody);
var slipperyMat = new CANNON.Material();
var friction = 0.0;
var restitution = 0.25;
var slipperyContact = new CANNON.ContactMaterial(slipperyMat,slipperyMat,friction,restitution);
world.addContactMaterial(slipperyContact);


let tb1=6;
let tb2=12;
let tb3=0.2;

tb1*=2;

const tableBshape = new CANNON.Box(
    new CANNON.Vec3(tb1 / 2, tb2 / 2, tb3 / 2)
  );
  let tb_mass = 0;
//   let  Tablebody = new CANNON.Body({ mass:tb_mass, shpae: tableBshape });
var Tablebody = new CANNON.Body({
    mass: 0, // mass == 0 makes the body static
    material:slipperyContact
});
  Tablebody.position.set(0, 0, -1);
  Tablebody.addShape(tableBshape);
world.addBody(Tablebody);


const geo1 = new THREE.BoxGeometry( tb1, tb2, tb3 );
const mat1 = new THREE.MeshLambertMaterial( {color: 0x959f9b} );
const table = new THREE.Mesh( geo1, mat1 );
table.position.set(0,0,-1);
scene.add(table);



const geo2 = new THREE.SphereGeometry( 0.1, 32, 32 );
const mat2 = new THREE.MeshBasicMaterial( {color: 0xff9000,map:normalTexture} );
const sphere = new THREE.Mesh( geo2, mat2 );
sphere.position.set(sphere_posx,sphere_posy,sphere_posz);
scene.add( sphere );

let wma1=2;
let wma2=3;
let wma3=0.1;
let wmap1=2;
let wmap2=0;
let wmap3=0;
const geo3 = new THREE.BoxGeometry(wma1,wma2,wma3);
const mat3 = new THREE.MeshLambertMaterial( {color: 0x959f34} );
const weight_m1 = new THREE.Mesh( geo3, mat3 );
weight_m1.position.set(wmap1,wmap2,wmap3);
scene.add(weight_m1);

const wma_cs = new CANNON.Box(
    new CANNON.Vec3(wma1 / 2, wma2 / 2, wma3 / 2)
  );
  var wma_cb = new CANNON.Body({
    mass: 0, // mass == 0 makes the body static
    // material:slipperyContact
});
wma_cb.position.set(wmap1, wmap2, wmap3);
wma_cb.addShape(wma_cs);
world.addBody(wma_cb);


let wmb1=2;
let wmb2=3;
let wmb3=0.1;
let wmbp1=-2;
let wmbp2=0;
let wmbp3=0;
const geo4 = new THREE.BoxGeometry(wmb1,wmb2,wmb3);
const mat4 = new THREE.MeshLambertMaterial( {color: 0x009f34} );
const weight_m2 = new THREE.Mesh( geo4, mat4 );
weight_m2.position.set(wmbp1,wmbp2,wmbp3);
scene.add(weight_m2);

const wmb_cs = new CANNON.Box(
    new CANNON.Vec3(wmb1 / 2, wmb2 / 2, wmb3 / 2)
  );
  var wmb_cb = new CANNON.Body({
    mass: 0, // mass == 0 makes the body static
    material:slipperyContact
});
wmb_cb.position.set(wmbp1, wmbp2, wmbp3);
wmb_cb.addShape(wmb_cs);
world.addBody(wmb_cb);
console.log("started");


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
};

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
// const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
// const camera_width=window.innerWidth>600?28:15;
// const aspect_ratio=window.innerWidth/window.innerHeight;
// const camera_height=camera_width/aspect_ratio;

// const camera = new THREE.OrthographicCamera(
//     camera_width/-2,        //left
//     camera_width/2,         //right
//     camera_height/2,        //top
//     camera_height/-2,       //bottom
//     0,                      //near plane
//     1000                    //further plane
// )


// camera.position.set( 0, camera_offset*4, 30 ); // all components equal
// camera.lookAt( cube.position ); // or the origin
// scene.add(camera)
let camera_offset=10;
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.up.set(0,0,1);
camera.lookAt(0,0,0);
camera.position.x = 0;
camera.position.y = 12;
camera.position.z = 7.7;
scene.add(camera)




// Controls
const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */



const windowX=window.innerWidth/2;
const windowY= window.innerHeight/2;

// onDocumentMouseMove = (event) =>{
//     mouseX=(event.clientX-windowX);
//     mouseY=(event.clientY-windowY);
// }


const clock = new THREE.Clock()
sphereBody.velocity.set(0, 0, 0);
// const controls = new OrbitControls( camera, renderer.domElement );
const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    let timePassed=10;
    world.step(elapsedTime / 1000); // Step the physics world
    sphere.position.copy(sphereBody.position);
    table.position.copy(Tablebody.position);
    // console.log(Tablebody.position);
    console.log(sphereBody.velocity);
    // console.log(sphereBody.position);
    // console.log(camera.position);
    
    // Update Orbital Controls
    // controls.update()

    // Render
    renderer.render(scene, camera)
    // controls.update();
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
    },[])
    return (
        <div className="">
        <canvas class="webgl"></canvas>
        <div class="">
          
            
        </div>
        </div>
    )
}

export default Pi
